'use client'

import { useEffect } from 'react'
import { sendGTMEvent } from '@next/third-parties/google'

export default function EventPageNotFound() {
	useEffect(() => {
		sendGTMEvent({ event: 'pageNotFound' })
	}, [])
	return <></>
}
